import { useState } from 'react';

import { useDebounce } from '@/shared/hooks/use-debounce/use-debounce';

export const useSearchableSelect = <TOptionShape>(
  onSelectChange?: (
    selectedOptions: TOptionShape[],
    value: TOptionShape | TOptionShape[],
    setValue: (value: TOptionShape | TOptionShape[]) => void,
  ) => void,
) => {
  const [inputValue, setInputValue] = useState<string>('');
  const [shouldSearch, setShouldSearch] = useState(true);
  const debouncedSearch = useDebounce({
    value: shouldSearch ? inputValue : '',
  });

  const handleInputChange = (
    _: unknown,
    newInputValue: string,
    reason: string,
  ) => {
    // `inputValue` controls MUI's input, so it must track every reason or the
    // field freezes; only typing searches — text MUI writes back is no search term.
    setInputValue(newInputValue);
    setShouldSearch(reason === 'input');
  };

  const handleSelectChange = (
    selectedOptions: TOptionShape[],
    value: TOptionShape | TOptionShape[],
    setValue: (value: TOptionShape | TOptionShape[]) => void,
  ) => {
    setShouldSearch(false);
    if (onSelectChange) {
      onSelectChange(selectedOptions, value, setValue);
    }
  };

  return {
    inputValue,
    shouldSearch,
    debouncedSearch,
    handleSelectChange,
    handleInputChange,
  };
};
